// extracted by mini-css-extract-plugin
export default {"form3":"AddProduct_form3__Ce5JM","column":"AddProduct_column__vJ5cj","add":"AddProduct_add__QhOav"};